define("Pages/PrivacyChoices", [`Page`, `module`], function (Super, Self) {
	return Super.inherit({
		namespace: Self.id,
		requires: [`User`, `XHR`],
		defaults: {
			show: true,
			transition: `fade`,
			render: true,
		},
		async constructor(setup) {
			const { data } = this;

			this.create({
				namespace: `Modules/PageHeader`,
				setup: {
					name: `page-header`,
					showTixrLogo: true,
				},
			});

			this.create({
				namespace: `Modules/PageFooter`,
				setup: {
					name: `page-footer`,
				},
			});

			await this.create({
				namespace: `Widgets/Form`,
				setup: {
					name: `form`,
					theme: `DARK`,
					inputs: {
						doNotSharePII: {
							type: `Checkbox`,
							value: false,
							rules: {
								label: `Enable`,
							},
							validation: {
								type: `Boolean`,
							},
						},
						limitUseOfPII: {
							type: `Checkbox`,
							value: false,
							rules: {
								label: `Enable`,
							},
							validation: {
								type: `Boolean`,
							},
						},
					},
					callbacks: {
						update: (value, key, inputs) => {
							if (typeof data.doNotSharePII !== `undefined`) {
								const { doNotSharePII, limitUseOfPII } = this.instances.form.getValue();
								data.doNotSharePII === doNotSharePII && data.limitUseOfPII === limitUseOfPII
									? this.select(`[action="save"]`).addClass(`disabled`)
									: this.select(`[action="save"]`).removeClass(`disabled`);
							}
						},
					},
				},
			});

			this.init();
		},
		api: {
			init: {
				async: true,
				value() {
					const { App, data, instances, User } = this;

					return User.get({
						subscribe: true,
						then: (user) => {
							data.user = user;

							if (this.isArray(user.privacyChoices, 1)) {
								const value = this.find(user.privacyChoices, { type: `TIXR` });

								if (value) {
									data.doNotSharePII = value.doNotSharePII;
									data.limitUseOfPII = value.limitUseOfPII;
								}
							} else {
								data.doNotSharePII = false;
								data.doNotSharePII = false;
							}

							if (App.getCookie(`doNotSharePII`) || App.getCookie(`limitUseOfPII`)) {
								App.deleteCookie(`doNotSharePII`);
								App.deleteCookie(`limitUseOfPII`);
							}

							const { doNotSharePII, limitUseOfPII } = data;
							instances.form.setValue({ value: { doNotSharePII, limitUseOfPII } });
							this.select(`[action="save"]`).addClass(`disabled`);
						},
						fail: () => {
							// Fallback to cookies for logged out users
							const doNotSharePII = App.getCookie(`doNotSharePII`) === `true`;
							const limitUseOfPII = App.getCookie(`limitUseOfPII`) === `true`;
							instances.form.setValue({ value: { doNotSharePII, limitUseOfPII } });
							data.doNotSharePII = doNotSharePII;
							data.limitUseOfPII = limitUseOfPII;
						},
					});
				},
			},
			save: {
				async: true,
				value() {
					const { App, data, instances, XHR } = this;
					const body = instances.form.getValue();
					const url = `/api/user/privacy-choices`;
					const promise = XHR.ajax({ url, type: `POST`, body, REST: true });

					return this.when({
						promise,
						then: (response) => {
							App.notifyUser({
								done: true,
								message: `Successfully saved Privacy Choices`,
								type: `success`,
							});
							data.doNotSharePII = body.doNotSharePII;
							data.limitUseOfPII = body.limitUseOfPII;
							this.select(`[action="save"]`).addClass(`disabled`);
						},
					});
				},
			},
		},
		listeners: [
			{
				event: `click`,
				filter: `[action="login"]`,
				handler(evt) {
					this.App.loadOverlay({
						type: `LogInOverlay`,
						replace: true, // don't keep this overlay running
						setup: {
							allowSignUp: true,
						},
						done: true,
					});
				},
			},
			{
				event: `click`,
				filter: `[action="save"]`,
				handler(evt) {
					const { App, data } = this;

					if (data.user) {
						this.save();
					} else {
						// Fallback to cookies for logged out users
						const { doNotSharePII, limitUseOfPII } = this.instances.form.getValue();
						App.setCookie(`doNotSharePII`, doNotSharePII);
						App.setCookie(`limitUseOfPII`, limitUseOfPII);

						App.notifyUser({
							done: true,
							message: `Successfully saved Privacy Choices`,
							type: `success`,
						});
						data.doNotSharePII = doNotSharePII;
						data.limitUseOfPII = limitUseOfPII;
						this.select(`[action="save"]`).addClass(`disabled`);
					}
				},
			},
		],
	});
});

define("Pages/PrivacyChoices.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Pages/PrivacyChoices/main"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<header class=\"head\"> <div name=\"page-header\"></div> <div class=\"scroll-head-background\"></div> </header> <main class=\"body\"> <div class=\"content header\"> <h1> Privacy Choices </h1> </div> <div class=\"content main\"> <div name=\"form\"> <div class=\"flex-row\"> <div class=\"flex-column\"> <h2> Do not share or sell my personal information </h2> <p> We disclose personal information as described in our privacy policy for different purposes, including to bring you more relevant ads, helping you discover content, and providing a more tailored experience to you on our services. Some of these disclosures may be considered a \"sharing\" of personal information for \"cross-context behavioral advertising\" and \"targeted advertising\" or a \"sale\" of personal information under relevant law. Based on where you live, you may have the right to opt out of these disclosures by us, as well as our use of your personal information for targeted advertising, by enabling this setting. </p> </div> <div class=\"flex-column\"> <div name=\"doNotSharePII\"></div> </div> </div> <div class=\"flex-row\"> <div class=\"flex-column\"> <h2> Limit the use of my sensitive personal information </h2> <p> Based on where you live, you may have the right to limit Tixr's use and disclosure of personal information that the law considers being sensitive. To do so, please enable this setting. </p> </div> <div class=\"flex-column\"> <div name=\"limitUseOfPII\"></div> </div> </div> </div> <p> <strong>Note:</strong> If you do not have a Tixr account or are not logged in to your Tixr account, this setting will only apply to the browser you are currently using. If you would like this setting to apply to your Tixr account, please <a href=\"#\" action=\"login\">log in</a> and return to this page. </p> <div class=\"button-wrapper\"> <a href=\"#\" action=\"save\" class=\"button small disabled\" theme=\"BLUE\"> <p>Save</p> </a> </div> </div> </main> <footer class=\"content footer\"> <div name=\"page-footer\"></div> </footer> ";
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=PrivacyChoices.js.map